module.exports = __webpack_public_path__ + "img/icon4.60aefb37.png";